import { Button } from '@/components/Button';
import { Helmet } from 'react-helmet-async';
import { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import confetti from 'canvas-confetti';
import UnlockedIcon from '@/assets/images/common/unlocked.png';
import { useTranslation, Trans } from 'react-i18next';
import SubscriptionFeedbackModal from '@/features/firstTimeExperience/SubscriptionFeedbackModal';

function CheckoutBasicSuccess() {
    const navigate = useNavigate();
    const { t } = useTranslation('checkout');
    const [showFeedbackModal, setShowFeedbackModal] = useState<boolean>(true);

    useEffect(() => {
        setTimeout(() => {
            // 紙吹雪アニメーション
            const end = Date.now() + 3 * 1000;
            const colors = ['#FFD700', '#FFB84C', '#E6FF66'];
            (function frame() {
                // 左
                confetti({
                    particleCount: 3,
                    angle: 45,
                    spread: 55,
                    origin: { x: 0 },
                    scalar: 1.5,
                    colors: colors,
                });
                // 右
                confetti({
                    particleCount: 3,
                    angle: 135,
                    spread: 55,
                    origin: { x: 1 },
                    scalar: 1.5,
                    colors: colors,
                });
                if (Date.now() < end) {
                    requestAnimationFrame(frame);
                }
            })();
            // 1秒待ってから実行
        }, 2000);
    }, []);

    return (
        <>
            <Helmet>
                <title>{t('success.title')}</title>
            </Helmet>

            <div className="flex flex-col items-center justify-center h-screen py-10 px-4 gap-6 text-center text-gray-800">
                <h1 className="text-2xl lg:text-4xl font-bold leading-[1.8] tracking-widest mt-4">
                    <Trans
                        t={t}
                        i18nKey="success.hero"
                        components={{
                            0: <span className="text-4xl lg:text-6xl text-yellow-600" />,
                        }}
                    />
                </h1>
                <div className="flex flex-col items-start justify-center gap-4">
                    <img
                        src={UnlockedIcon}
                        alt="Unlocked"
                        className="w-40 h-40 image-protection me-2"
                    />
                </div>
                <p
                    className="text-lg leading-[2.2] tracking-widest"
                    dangerouslySetInnerHTML={{
                        __html: t('success.description', { interpolation: { escapeValue: false } }),
                    }}
                />
                <p className="text-lg leading-[2.2] tracking-widest">
                    <Trans
                        t={t}
                        i18nKey="success.support"
                        components={{
                            0: (
                                <a
                                    href="/faq"
                                    target="_blank"
                                    rel="noopener noreferrer"
                                    className="text-blue-500 text-lg leading-[1.8] tracking-widest underline"
                                />
                            ),
                            1: (
                                <a
                                    href="/settings"
                                    target="_blank"
                                    rel="noopener noreferrer"
                                    className="text-blue-500 text-lg leading-[1.8] tracking-widest underline"
                                />
                            ),
                        }}
                    />
                </p>
                {/* デスクに戻るボタン */}
                <Button
                    onClick={() => navigate('/desk')}
                    className="h-16 w-auto tracking-[0.2em]"
                    variant="original"
                >
                    {t('success.cta')}
                </Button>
            </div>

            <SubscriptionFeedbackModal
                isOpen={showFeedbackModal}
                onClose={() => setShowFeedbackModal(false)}
            />
        </>
    );
}

export default CheckoutBasicSuccess;
